// Preview modal in the cart for Customised Products
const selectors = {
    modal: '[data-hg-c-preview-modal]',
    closeTrigger: '[data-hg-c-preview-close]',
    openTrigger: '[data-hg-c-preview-open]',
};
const initModal = () => {
    const modal = document.querySelector(selectors.modal);
    const openTriggers = document.querySelectorAll(selectors.openTrigger);
    if (modal && openTriggers) {
        openTriggers.forEach((openBtn) => {
            openBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const previewImage = openBtn.dataset.hgCPreviewOpen;
                const imageElem = modal.querySelector('img');
                imageElem.src = previewImage;
                modal.classList.add('open');
            });
        });
        const closeBtns = document.querySelectorAll(selectors.closeTrigger);
        closeBtns.forEach((closeBtn) => closeBtn.addEventListener('click', (e) => {
            e.preventDefault();
            modal.classList.remove('open');
        }));
    }
};
export default initModal;
